import React from 'react';
import c from '../w.js';

const IconFileAudio = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M19.8356 2.19403C20.4451 2.09244 21 2.56248 21 3.18042V15.6804C21 17.6134 19.433 19.1804 17.5 19.1804C15.567 19.1804 14 17.6134 14 15.6804C14 13.7474 15.567 12.1804 17.5 12.1804C18.0368 12.1804 18.5454 12.3013 19 12.5172V6.52755C19 5.90961 18.4451 5.43957 17.8356 5.54116L9.8356 6.87449C9.35341 6.95485 9 7.37205 9 7.86088V17.6804C9 19.6134 7.433 21.1804 5.5 21.1804C3.567 21.1804 2 19.6134 2 17.6804C2 15.7474 3.567 14.1804 5.5 14.1804C6.0368 14.1804 6.54537 14.3013 7 14.5172V5.18042C7 4.69158 7.35341 4.27439 7.8356 4.19403L19.8356 2.19403Z" })
  )
);

export { IconFileAudio };
